module.exports = __webpack_public_path__ + "img/portrait-037.449e1138.jpg";